import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	previewTitle: {
		id: 'portfolio-3-financial-year-dates.ui.preview.preview-title',
		defaultMessage: 'Preview',
		description: 'The title for the preview',
	},
	quarterColumnHeading: {
		id: 'portfolio-3-financial-year-dates.ui.preview.quarter-column-heading',
		defaultMessage: 'Quarter',
		description: 'The heading for quarters column in the financial year preview table',
	},
	datesColumnHeading: {
		id: 'portfolio-3-financial-year-dates.ui.preview.dates-column-heading',
		defaultMessage: 'Dates',
		description: 'The heading for dates column in the financial year preview table',
	},
	quarterRange: {
		id: 'portfolio-3-financial-year-dates.ui.preview.quarter-range',
		defaultMessage: '{startMonth} to {endMonth}',
		description: 'Describes the quarter range from start month to end month',
	},
	quarterDescription: {
		id: 'portfolio-3-financial-year-dates.ui.preview.quarter-description',
		defaultMessage: 'Q1 starts on {quarterOneStart} and Q4 ends on {quarterFourEnd}.',
		description: 'Describes the quarter range from start month to end month',
	},
});
